import React from 'react';
import { IRequestsSplitDetail } from './_types';
import { StudiesSplitDetail } from 'modules/Studies/StudiesSplit/StudiesSplitDetail';

const RequestsSplitDetail: React.FC<IRequestsSplitDetail> = () => (
  <StudiesSplitDetail isRequest={true} />
);

export default RequestsSplitDetail;
